/**
 * System helper.
 */
import * as sysInfo from 'systeminformation';
const osLocale = require('os-locale');

class SystemInfo {

    /**
     * Get system information.
     */
    static async getSystemInfo() {
        const [cpu, graphics, mem, osInfo, system] = await Promise.all([
            sysInfo.cpu(),
            sysInfo.graphics(),
            sysInfo.mem(),
            sysInfo.osInfo(),
            sysInfo.system(),
        ]);

        let distro = osInfo.distro;
        distro = (distro.startsWith('Microsoft') ? distro.substr(10) : distro);
        distro = (osInfo.servicepack.startsWith('0') ? distro : distro + ' SP' + osInfo.servicepack);

        return [
            distro,
            `(${osInfo.kernel})`,
            `${Math.round(mem.total / 2**30)}GB RAM,`, // 2^30 = 1024 * 1024 * 1024
            cpu.manufacturer.replace('®',''),
            cpu.brand.replace('™',''),
            `${cpu.cores}CPU`,
            `${cpu.speed}GHz,`,
            `Graphics: ${graphics.controllers.map(c => c.model).join(', ')},`,
            `Model: ${system.manufacturer} ${system.model}`
        ].join(' ');
    }

    static async getSystemCores() {
        return (await sysInfo.cpu()).cores;
    }

    /**
     * Get locale string. Replace '_' with '-'.
     */
    static async getLocale() {
        return (await osLocale()).replace('_', '-');
    }
}

export default SystemInfo;
